/*主要是处理经营类目录数据处理逻辑的混入*/
export default {
  name: "applay-show-category",
  data() {
    return {
      isAll: 0
    };
  },
  methods: {
    //编辑页面页面的数据反显
    dataShowEdit(categoryBosList) {
      this.defaultPitchOn = [];
      this.categoryBos = [];
      this.categoryData = [];
      console.log(categoryBosList);
      categoryBosList.forEach(item1 => {
        item1.isAll = item1.isAll == 1 ? true : false;
      });
      //弹框回显的数据
      let categoryBosList1 = JSON.parse(JSON.stringify(categoryBosList));
      if (categoryBosList.length > 0)  {
        console.log("🚀 ~ 1111111111111:", categoryBosList1)
        this.defaultPitchOn = categoryBosList1
      }

      let arrlistNames = [],
        arrlistcategoryCodes = [],
        arrListChildName = [],
        arrListChildCode = [];
      categoryBosList1.forEach(item => {
        //页面反显展示逻辑
        this.categoryData.push({
          categoryName: item.categoryNames,
          categoryCode: item.categoryCodes
        });

        //下面是弹框的反显展示逻辑
        arrlistNames = item.categoryNames.split(">");
        arrlistcategoryCodes = item.categoryCodes.split(",");

        for (let k = 0; k < arrlistNames.length; k++) {
          //一级和二级目录的name和code
          //第三项开始为三级目录
          if (k >= 2) {
            arrListChildName = arrlistNames[k].split("\\");
            arrListChildCode = arrlistcategoryCodes[k].split("\\");
            for (let s = 0; s < arrListChildName.length; s++) {
              this.categoryBos.push({
                categoryName: arrListChildName[s],
                categoryCode: arrListChildCode[s],
                isAll: item.isAll
              });
            }
          }
        }
      });

      console.log(this.defaultPitchOn, "defaultPitchOn需要弹框反显的数据");
    },
    //经营类目数据的展示处理
    selectDataShowFun() {
      console.log(this.selectData, "过滤后需要展示的数据");
      let objShowData = {};
      this.selectData.forEach(item => {
        //一级展示
        if (
          item.shopSecondCategoryBOS &&
          item.shopSecondCategoryBOS.length > 0
        ) {
          item.shopSecondCategoryBOS.forEach((item2, index2) => {
            objShowData = {};
            objShowData.categoryName = item.categoryName + ">";
            //二级选中的数据展示
            if (item2.isSelected) {
              objShowData.categoryName =
                objShowData.categoryName + item2.categoryName + ">";

              item2.shopThirdCategoryBOS.forEach((item3, ind) => {
                //三级选中的数据展示
                if (item3.isSelected) {
                  if (ind === item2.shopThirdCategoryBOS.length - 1) {
                    objShowData.categoryName =
                      objShowData.categoryName + item3.categoryName;
                  } else {
                    objShowData.categoryName =
                      objShowData.categoryName + item3.categoryName + "\\";
                  }
                }
              });

              //二级数据处理完一项然后push进入数组 展示
              this.categoryData.push(objShowData);
            }
          });
        }
      });
      console.log(this.categoryData, "过滤完最终需要展示的数据");
    },

    //递归处理经营类目选中的数据
    traverseData(dataArr) {
      //统计一下有几个一级大类没有二级数据的
      let countData = 0;

      //存在下级数据而且长度大于0 那么继续遍历
      dataArr.forEach(item => {
        //isAll判断是否全选
        //isSelected主要是判断一级和二级是否有选中的下级类目
        if (item.isSelected) {
          //是否全部选中 是1 否0
          if (item.isAll) {
            this.isAll = 1;
          } else {
            this.isAll = 0;
          }
          //选中的数据
          this.selectData.push(item);
        } else {
          countData++;
        }
      });

      //这个是确定是否是没选中数据的情况下  如果不选中如何数据 置空
      if (countData === dataArr.length) {
        console.log("没有选中任何数据");
        //点击确定没选中任何数据
        this.categoryData = [{ categoryName: "请选择经营类目" }];
        //选中数据过滤
        this.selectData = [];
      }
    },
    refdata(data) {
      this.mockData = JSON.parse(JSON.stringify(data))
      console.log('22222222222222222222', data)
      this.defaultPitchOn = JSON.parse(JSON.stringify(data))
    },
    // 经营类目确定
    determine(checkArr) {
      this.defaultPitchOn = JSON.parse(JSON.stringify(checkArr));
      console.log(checkArr, "确定选中的数据");
      //选中数据过滤
      this.selectData = [];
      //展示数据用
      this.categoryData = [];

      //递归数据 过滤一下
      this.traverseData(JSON.parse(JSON.stringify(checkArr)));
      //选中的数据进行拼接展示
      if (this.selectData && this.selectData.length > 0) {
        this.selectDataShowFun();
      }
      if (
        this.categoryData &&
        this.categoryData.length > 0 &&
        this.categoryData[0].categoryName !== "请选择经营类目"
      ) {
        this.form.categoryData = "有数据";
        //清除校验
        this.$refs["form"].clearValidate("categoryData");
      } else {
        this.form.categoryData = ""; //添加校验
        this.$refs["form"].validateField("categoryData");
      }
    }
  }
};
